module.exports = __webpack_public_path__ + "static/media/Scroll-down.cc3fc68f.svg";